import { BadgeInfo } from 'lucide-react';
import Modal from '../shared/Modal';

// Reusable modal for warning about files with a specific tag
interface TagFileWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage: string | null;
  onDeleteAll: () => void;
  tagLabel?: string;
}

const TagFileWarningModal: React.FC<TagFileWarningModalProps> = ({
  isOpen,
  onClose,
  errorMessage,
  onDeleteAll,
  tagLabel = 'ภาพทั้งหมด',
}) => {
  if (!isOpen) return null;
  return (
    <Modal
      onClose={onClose}
      isBackgroundTransparent={true}
      hideTopPadding={true}
    >
      <div className="p-6">
        <div className="flex items-center mb-3">
          <BadgeInfo className="h-6 w-6 text-blue-900 mr-2" />
          <h3 className="text-lg font-semibold text-blue-900">ช้าก่อน!</h3>
        </div>
        <div className="text-blue-900 mb-6 text-base">
          {errorMessage}
        </div>
        <div className="flex justify-end gap-2 w-full">
          <button
            onClick={onDeleteAll}
            className="px-4 py-2 text-base text-blue-900 bg-blue-100 border border-blue-500 rounded-md hover:bg-blue-200"
            data-cy="modal-error-deleteall-button"
          >
            ลบ{tagLabel}
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 text-base text-white bg-blue-900 rounded-md hover:bg-blue-800"
            data-cy="modal-error-close-button"
          >
            ปิด
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TagFileWarningModal;